export enum WarrantyStatus {
  ACCEPTED = 'Accepted',
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
  EXPIRED = 'Expired',
  IN_PROGRESS = 'In Progress',
  IN_REVIEW = 'In Review',
  DECLINED = 'Declined',
  IN_DEALER_CORRECTION = 'In Dealer Correction',
}
